// extracted by mini-css-extract-plugin
module.exports = {"hiddenContent":"FormSlidesLoader_hiddenContent__B8DGX"};